import { UUID } from 'crypto';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';

interface StowageChangeDataTypeMapItem {
    type: StowageChangeDataType;
    key: string;
    guidKey: string;
}

const stowageChangeDataMap: StowageChangeDataTypeMapItem[] = [
    { type: StowageChangeDataType.StowageItem, key: 'stowageItem', guidKey: 'stowageGuid' },
    { type: StowageChangeDataType.BlockedTank, key: 'blockedTank', guidKey: 'blockedTankGuid' },
    { type: StowageChangeDataType.AdjustedCargoTemperature, key: 'adjustedCargoTemperature', guidKey: 'adjustedCargoTemperatureGuid' },
    { type: StowageChangeDataType.Violation, key: 'violation', guidKey: 'violationGuid' },
    { type: StowageChangeDataType.RotationPortCall, key: 'portCall', guidKey: 'portCallGuid' },
    { type: StowageChangeDataType.RotationBerthCall, key: 'berthCall', guidKey: 'berthCallGuid' },
    { type: StowageChangeDataType.RotationCargoOperation, key: 'cargoOperation', guidKey: 'cargoOperationGuid' },
    { type: StowageChangeDataType.RotationCargo, key: 'cargo', guidKey: 'cargoGuid' },
];

const stowageChangeKeyMap: Record<StowageChangeDataType, string> = stowageChangeDataMap.reduce((acc, item) => {
    acc[item.type] = item.key;
    return acc;
}, {} as Record<StowageChangeDataType, string>);

// TODO: RETURN-TYPE - Function can return undefined but return type doesn't reflect this
export const getStowageChangeKey = (changeDataType: StowageChangeDataType): string | undefined => {
    return stowageChangeKeyMap[changeDataType];
};

export const getChangeDataGuidKey = (changeDataType: StowageChangeDataType): string | undefined => {
    return stowageChangeDataMap.find((data) => data.type === changeDataType)?.guidKey;
};

// TODO: TYPE-SAFETY - Function parameter 'item' should have proper typing instead of 'any'
export const getChangeDataGuid = (changeDataType: StowageChangeDataType, item: any): UUID | null => {
    const guidKey = getChangeDataGuidKey(changeDataType);
    return guidKey ? item[guidKey] || null : null;
};

// TODO: TYPE-SAFETY - Function parameter 'item' should have proper typing instead of 'any'
// TODO: FUNCTION-MUTATION - Function mutates the input parameter 'item'
export const setChangeDataGuid = (changeDataType: StowageChangeDataType, item: any, guidValue: UUID) => {
    const guidKey = getChangeDataGuidKey(changeDataType);
    if (guidKey) {
        item[guidKey] = guidValue;
    }
};
